<ng-container *ngIf="visible">
  <div class="progress">
    <div class="progress-bar-custom"></div>
  </div>
</ng-container>
